// extracted by mini-css-extract-plugin
export default {"container":"AM-z","error":"BM-z","disabled":"CM-z","submit":"DM-z","option":"EM-z","success":"FM-z","failure":"GM-z"};